// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());


// @codekit-prepend "jquery-3.4.1.min.js" quiet;
// @codekit-prepend "jquery-migrate-3.1.0.min.js" quiet;
// @codekit-prepend "jquery.cycle2.min.js" quiet;
// @codekit-prepend "jquery.cycle2.swipe.min.js" quiet;
// @codekit-prepend "jquery.cycle2.carousel.min.js" quiet;

// @codekit-prepend "cookieconsent.min.js" quiet;
// @codekit-prepend "cookieconsent-google_analytics.js" quiet;





jQuery.noConflict();
(function($) {	
	    
	$('.archive-events .event-item .description').hide();
	
	$('.archive-events .event-item .description-wrapper > .button-wrapper > button').click( function(){
		$(this).hide(50);
		$(this).parent().next().delay(50).slideDown(600);
	});
	
	$('.archive-events .event-item .description .button-wrapper button').click( function(){
		$(this).parent().parent().slideUp(600);
		$(this).parent().parent().prev().find('button').delay(600).show(50);
	});


	$('.archive-events a[href*=#]').click(function(event){
		
	    $('html, body').animate({
	        scrollTop: $( $.attr(this, 'href') ).offset().top
	    }, 500);
    event.preventDefault();
});

// end --------------------------------------------------------------------------------------------
}(jQuery));